var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-1"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[(_vm.permission.report.hotel_service.hotel_order_report)?_c('v-btn',{staticClass:"btnReport ml-2",attrs:{"color":"#FFD600","to":'/weserve_admin_login/control/' +
          _vm.$store.state.backOffice.province +
          '/report/hotel-service/order-report'}},[_c('v-icon',[_vm._v("insert_drive_file")]),_c('span',{},[_vm._v("Order Report")])],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }